export default "__VITE_ASSET__DC0dMhzp__"